// ccw 2026-09-28 msl-map: Territory config for the interactive MSL map (/resources/msl).
// Territories, colors and liaison assignments live here — never in the SVG or CSS — so a
// staffing change is a config edit only. Liaison name, degree, title and photo still come
// from the getMSL API (neurelis_msl table); config liaisons are matched to it by email.
//
// Rules:
//  - A state belongs to at most one territory (states in none are "unassigned").
//  - A territory belongs to at most one liaison.
//  - A liaison can hold any number of territories; their order sets the photo-ring slice
//    order and the order of the region lines on the card.
//  - Liaison order here is the card order.
//
// PENDING CLIENT CONFIRMATION (Q3 2026 MSL Territory Map slide):
//  - Northeast "interim" label on Bernadett Mamone's card (note: 'interim' below)
//  - Copy for unassigned states (unassignedMessage) / whether MT, ND, SD, AK, HI get assigned
//  - Puerto Rico (not drawn), DC assignment (Mid-Atlantic & Southeast), phone numbers (not
//    shown), card order (geographic, west to east)

export const MSL_UNASSIGNED_COLOR = '#D5D9E3'
export const MSL_UNASSIGNED_MESSAGE = 'Not currently assigned. Contact Medical Affairs.'

// Invisible hit circles (radius in viewBox units) for states too small to target. They sit
// on the state's centroid unless cx/cy is given. MD's centroid is only 4 units from DC's,
// so the two circles would swallow each other; MD's is moved to its Eastern Shore instead.
export const MSL_HIT_TARGETS = {
	RI: { r: 10 },
	DE: { r: 10 },
	CT: { r: 10 },
	NJ: { r: 10 },
	MD: { r: 10, cx: 683.5, cy: 214.3 },
	DC: { r: 14 },
}

export const MSL_TERRITORIES = [
	{ id: 'west', label: 'West', color: '#3F63F0', states: ['WA', 'OR', 'CA', 'NV', 'ID', 'UT', 'AZ', 'WY', 'CO'] },
	{ id: 'southcentral', label: 'Southcentral', color: '#45B8AC', states: ['NM', 'TX', 'OK', 'KS', 'AR', 'LA', 'MS', 'AL'] },
	{ id: 'midwest', label: 'Midwest', color: '#16206B', states: ['NE', 'MN', 'IA', 'MO', 'WI', 'IL', 'MI', 'IN'] },
	{ id: 'midatlantic', label: 'Mid-Atlantic & Southeast', color: '#E8834F', states: ['OH', 'KY', 'WV', 'VA', 'MD', 'DE', 'DC', 'TN', 'NC', 'SC', 'GA', 'FL'] },
	{ id: 'northeast', label: 'Northeast', color: '#A24DB8', states: ['ME', 'NH', 'VT', 'MA', 'RI', 'CT', 'NY', 'PA', 'NJ'] },
]

export const MSL_LIAISONS = [
	{ id: 'sheppe', email: 'dsheppe@neurelis.com', territories: [{ id: 'west' }] },
	{ id: 'huff', email: 'ahuff@neurelis.com', territories: [{ id: 'southcentral' }] },
	{ id: 'mancoci', email: 'dmancoci@neurelis.com', territories: [{ id: 'midwest' }] },
	{ id: 'mamone', email: 'bmamone@neurelis.com', territories: [{ id: 'midatlantic' }, { id: 'northeast', note: 'interim' }] },
]

// Validate once at load so a bad config edit shows up in the console instead of silently
// mis-coloring the map.
const validateMslConfig = () => {
	const stateOwner = {}
	MSL_TERRITORIES.forEach(t => t.states.forEach(s => {
		if (stateOwner[s]) console.error(`MSL config: ${s} is in both "${stateOwner[s]}" and "${t.id}".`)
		stateOwner[s] = t.id
	}))
	const territoryOwner = {}
	MSL_LIAISONS.forEach(l => l.territories.forEach(t => {
		if (!MSL_TERRITORIES.some(cur => cur.id === t.id)) console.error(`MSL config: liaison "${l.id}" references unknown territory "${t.id}".`)
		if (territoryOwner[t.id]) console.error(`MSL config: territory "${t.id}" is assigned to both "${territoryOwner[t.id]}" and "${l.id}".`)
		territoryOwner[t.id] = l.id
	}))
}
validateMslConfig()
